// client/src/services/notificationService.js

// Gestionnaire central des notifications
class NotificationService {
  constructor() {
    this.listeners = [];
    this.notifications = [];
    this.nextId = 1;
  }

  // Ajouter un écouteur pour les mises à jour de notifications
  addListener(listener) {
    this.listeners.push(listener);
    return () => this.removeListener(listener);
  }

  // Supprimer un écouteur
  removeListener(listener) {
    this.listeners = this.listeners.filter(l => l !== listener);
  }

  // Notifier tous les écouteurs
  notifyListeners() {
    this.listeners.forEach(listener => listener(this.notifications));
  }

  // Ajouter une nouvelle notification
  addNotification(message, type = 'info', duration = 6000) {
    const id = this.nextId++;
    
    const notification = {
      id,
      message,
      type,
      duration,
      timestamp: Date.now()
    };
    
    this.notifications.push(notification);
    this.notifyListeners();
    
    // Auto-supprimer après la durée spécifiée si duration > 0
    if (duration > 0) {
      setTimeout(() => {
        this.removeNotification(id);
      }, duration);
    }
    
    return id;
  }

  // Supprimer une notification par son ID
  removeNotification(id) {
    const index = this.notifications.findIndex(notif => notif.id === id);
    
    if (index !== -1) {
      this.notifications = [
        ...this.notifications.slice(0, index),
        ...this.notifications.slice(index + 1)
      ];
      
      this.notifyListeners();
    }
    
    return this.notifications;
  }

  // Supprimer toutes les notifications
  clearAllNotifications() {
    this.notifications = [];
    this.notifyListeners();
  }

  // Méthodes par type pour une utilisation plus simple
  success(message, duration = 6000) {
    return this.addNotification(message, 'success', duration);
  }

  error(message, duration = 8000) {
    return this.addNotification(message, 'error', duration);
  }

  warning(message, duration = 7000) {
    return this.addNotification(message, 'warning', duration);
  }

  info(message, duration = 6000) {
    return this.addNotification(message, 'info', duration);
  }
}

// Exporter une instance unique du service
const notificationService = new NotificationService();
export default notificationService;